import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import "./index.css";

import NoDriverSelected from "../../../Components/ManageDriver/SubComponents/NewDriverSideSection/SubComponents/NoDriverSelected";

import { useParams } from "react-router-dom";
import { storeDataToAsyncStorage } from "../../../services/Utils/functions";
import DriverInfo from "../../ManageDriver/SubComponents/NewDriverSideSection/SubComponents/DriverInfo";
import { Table } from "reactstrap";
import DriverSalaryInfo from "./DriverSalaryInfo";
import PaySalary from "./PaySalary";
import SvgImage from "../../Icons/Icons";
import AddingFilter from "../../Modals/addingFilter";
import moment from "moment";
import { cleanExpenseWalletSummary, getExpenseWalletSummary } from "../../../services/Store/Actions/driverslistActions";
import { getMasterAccountStatement } from "../../../services/Store/Actions/fleetActions";
import BulkSalary from "./BulkSalary";
import ReactPaginate from "react-paginate";

const SalarySideDiv=(props)=>{

    const [ currOption, setCurrOption]=useState(0);
    const {cardType, driverDetails, driverCardStatus, userId, driverFleet,setVehicleNumber, driverID}= props;
    const {id}= useParams();
    const [active1, setActive1] = useState(false)
    const [active2, setActive2] = useState(false)
    const [managerId, setManagerId] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [offsetMaster, setOffsetMaster] = useState(0);
    const [offset, setOffset] = useState(0);
    const [check, setCheck] = useState(false);
    const [start, setStart] = useState("");
    const [end, setEnd] = useState("");
    const  {expenseWalletSummaryList,salaryWalletSummary,
      salaryWalletSummaryCount}  = useSelector(
      (state) => state?.driverlist);
      console.log('hereeeeeeeee', salaryWalletSummary,expenseWalletSummaryList);
    const closing1 = () => {
      setActive1(false);
    }
    const showing1 = () => {
      setActive1(true);
    }
    const toggling1 = () => {
      setActive1(!active1);
    }
    const closing2 = () => {
      setActive2(false);
    };
  
    const toggling2 = () => {
      setActive2(!active2);
    };
  
    const showing2 = () => {
      setActive2(true);
    };
    const totalExpenseCount = expenseWalletSummaryList?.count===undefined?0:expenseWalletSummaryList?.count;
    const pageCount= (totalExpenseCount%10)===0?(totalExpenseCount/10):Math.floor(totalExpenseCount/10)+1;
    console.log(pageCount);
    // const pageCount=3;
    const handlePageClick = (event) => {
      console.log("Clickess");
      const newOffset = ((event.selected) * 10) ;
      console.log(
        `User requested page number ${event.selected}, which is offset ${newOffset}`
      );
      dispatch(
        getExpenseWalletSummary(id,{
          offset: newOffset,
          limit: "",
          sortBy: "",
          sortAs: "",
          isSalaryWallet:'1'
        })
      );
      setOffset(newOffset);
    };

    const filterFunc = async (startDate, endDate) => {
      setOffset(0);
      setOffsetMaster(0);
      setCheck(true);
      setStart(startDate);
      setEnd(endDate);  
        dispatch(cleanExpenseWalletSummary());
        dispatch(
          getExpenseWalletSummary(id,{
            offset: 0,
            limit: "",
            fromDate: moment(startDate).format("YYYY-MM-DD"),
            toDate: moment(endDate).format("YYYY-MM-DD"),
            sortBy: "",
            sortAs: "",
            isSalaryWallet:'1'
          })
        );
      
    }

    const downloadFunc = (startDate, endDate, mode) => {
        dispatch(getMasterAccountStatement(
          {
            from: moment(startDate).format("YYYY-MM-DD"),
            to: moment(endDate).format("YYYY-MM-DD"),
            mode: mode,
            userId: managerId,
  
          }, (res) => {
            if (res?.data?.type === "success") {
              if (res?.data?.data?.url) {
                window.open(res?.data?.data?.url);
              }
            }
          }
        )
        );  
    }

    const disableFilter = () => {
      setOffset(0);
      setCheck(false);
      setOffsetMaster(0);
      setManagerId('')
      setStart("");
      setEnd("");
        //console.log("TEST@@",check)
        dispatch(cleanExpenseWalletSummary());
        dispatch(
          getExpenseWalletSummary(id,{
            offset: 0,
            limit: "",
            fromDate: "",
            toDate: "",
            sortBy: "",
            sortAs: "",
            isSalaryWallet:'1'
            // userId: managerId
          })
        );
      
    }

    const dispatch= useDispatch();
    useEffect(()=>{
        const jsonValue = sessionStorage.getItem("_driverId");
        console.log("get token",jsonValue);
        let driverId= jsonValue != null ? JSON.parse(jsonValue) : null;

    },[id] )
    

    const omcDriverData= useSelector((state)=>state?.omc?.omcDriverData);

    
    useEffect(()=>{

        if(id){
            const cardnumObj = sessionStorage.getItem("_cardNum");
            const cardNumber = JSON.parse(cardnumObj);
            if(cardNumber)
                setCurrOption(cardNumber);
        }
        // else{
        //     setCurrOption(0);
        // }
    },[])


    const handleCardSelection=(num)=>{
        storeDataToAsyncStorage("_cardNum", num);
        setCurrOption(num);
    }
    
    return(
      <div className="padding16">
            {
                driverDetails=="Select Driver"?
                <NoDriverSelected name={'driverSalary'} />
                : driverDetails=="All Drivers"?
                <BulkSalary />
                :
            <>
                <DriverSalaryInfo 
                driverDetails={driverDetails}
                driverFleet={driverFleet}
                setVehicleNumber={setVehicleNumber}
                driverID={driverID}
                userId={id}
                cardType={cardType}
                />
                {/* <DriverSalaryInfo /> */}



                <PaySalary driverDetails={driverDetails} />


                 <div className="table-for-customer-receivable scrollableDivRec">
                  <div className="tableTop">
                    <div className="Bold heading2">
                      Transaction History
                    </div>
                    <div>
                      <div className="tableTop_right">
                      <div className="filterDates">
                        <div className="heading3 Bold">Filter Applied: </div>
                        <div className="FontNB" style={{ paddingLeft: "8px" }}>
                          {moment(start).format("DD-MM-YYYY") == "Invalid date" ? "None" : moment(start).format("DD-MM-YYYY") + " to"} {moment(end).format("DD-MM-YYYY") == "Invalid date" ? "" : moment(end).format("DD-MM-YYYY")}
                        </div>
                        <div style={{
                          paddingLeft: "8px", position: "relative", top: "-3px", cursor: "pointer",
                          visibility: moment(start).format("DD-MM-YYYY") == "Invalid date" ? "hidden" : "visible"
                        }}
                          onClick={disableFilter}>
                          <SvgImage
                            classname='close-btn-text'
                            // style={{ width: "10%", height: "10%" }}
                            name="CloseButtonLogo1"
                            width="20px"
                            height="20px"
                          />
                        </div>
                      </div>
                      <div className="heading3 semiBold" style={{cursor:'pointer'}} onClick={showing1}>
                        <SvgImage name='filter' />
                        <span style={{marginLeft:'10px'}}>Filter</span>
                      </div>
                      <div className="heading3 semiBold" style={{marginLeft:'20px', cursor:'pointer'}} onClick={showing2}>
                        <SvgImage name="downloadImgGreen" />
                        <span style={{marginLeft:'10px'}}>Download Statement</span>
                      </div>
                      </div>
                    </div>
                  </div>
                  <Table style={{marginTop:'12px'}}>
                    <thead>
                      <tr className="table-header-customer-details">
                        <th>Date</th>
                        <th>Amount</th>
                        <th>Transaction Number</th>
                        <th>Status</th>
                      </tr>
                    </thead>

                    <tbody>
                      {salaryWalletSummary?.map((item)=>{
                        let time = item?.createdAt.slice(11,16);
                        let date = item?.createdAt.slice(0,10);
                        const time12 = moment(time, 'HH:mm').format('h:mm A');
                        console.log('timeeeee', time, time12);
                          return(

                          <tr className="table-row-customer-details">
                            <td>
                              <div className="booking_title">
                                <p className="FontNB">{date}</p>
                              </div>
                              <div className="booking_total">
                                <p className="FontSmall">{time12}</p>
                              </div>
                            </td>
                            <td>
                              <div className="booking_title">
                                <p className="FontNB" style={{color: item?.type=='credit' ? 'green' : 'red'}}>₹{item?.amount}</p>
                              </div>
                              <div className="booking_total">
                                <p className="FontSmall" style={{color: item?.type=='credit' ? 'green' : 'red'}}>{item?.type}</p>
                              </div>
                            </td>
                            <td>
                              <div className="booking_title">
                                <p className="FontNB">{item?.id}</p>
                              </div>
                              <div className="booking_total">
                                <p className="FontSmall">{item?.remarks}</p>
                              </div>
                            </td>
                            <td>
                              <div className="booking_title">
                                <p className="FontNB" style={{color: item?.status==1 ? 'green' : 'red'}}>{item?.status == 1 ? "Success" : item?.status == 0 ?"Processing" : "Failed"}</p>
                              </div>
                            </td>
                          </tr>
                          )
                      })}
                      {
                        pageCount>1?
                          <div className="reactPagination">
                          <ReactPaginate
                            breakLabel="..."
                            nextLabel=" >"
                            onPageChange={handlePageClick}
                            pageRangeDisplayed={5}
                            pageCount={pageCount}
                            previousLabel="<"
                            renderOnZeroPageCount={null}
                            breakClassName={"page-item"}
                            breakLinkClassName={"page-link"}
                            containerClassName={"pagination"}
                            pageClassName={"page-item"}
                            pageLinkClassName={"page-link"}
                            previousClassName={"page-item"}
                            previousLinkClassName={"page-link"}
                            nextClassName={"page-item"}
                            nextLinkClassName={"page-link"}
                            activeClassName={"active"}
                          />
                        </div>
                        :<></>
                      }
                    </tbody>
                  </Table>
              </div>
              <AddingFilter
                active={active1}
                toggleModal={toggling1}
                handleClose={closing1}
                func={filterFunc}
                name="Filter"
                mixPanelName="Filter_Txn_salaryWallet"
                MP_sDate="SDate_Filter_Txn_salaryWallet"
                MP_eDate="EDate_Filter_Txn_salaryWallet"
                MP_close="Cut_Filter_Txn_salaryWallet" 
                MP_apply="Apply_Filter_Txn_salaryWallet"
                // managerId={managerId}
                startDate={startDate}
                endDate={endDate}
                setStartDate={setStartDate}
                setEndDate={setEndDate}
                setManagerId={setManagerId}
              />
              <AddingFilter
                active={active2}
                toggleModal={toggling2}
                handleClose={closing2}
                func={downloadFunc}
                name="Download History"
                // ma={true}
                startDate={startDate}
                endDate={endDate}
                setStartDate={setStartDate}
                setEndDate={setEndDate}
                setManagerId={setManagerId}
                // managerId={managerId}
                mixPanelName="Download_Txn_MA_Web"
                MP_sDate="SDate_Download_Txn_MA_Web"
                MP_eDate="EDate_Download_Txn_MA_Web"
                MP_close="Cut_Download_Txn_MA_Web"
                MP_apply="Apply_Download_Txn_MA_Web"
                MP_format="Format_Download_Txn_MA_Web"
                MP_PDF="PDF_Format_Download_Txn_MA_Web"
                MP_excel="Excel_Format_Download_Txn_MA_Web"
              />
            </>
            }

      </div>
    )
}
export default SalarySideDiv